<template>
  <div class="header-mobile">
    <a href="javascript:;" class="logo">
      <img src="@/images/logo.png" alt="logo" />
    </a>
    <div class="right-btn">
      <a href="javascript:;" class="icon" v-if="onShow!==undefined" @click="onShow">
        <i class="el-icon-menu" />
      </a>
      <a href="javascript:;" class="icon" @click="()=>drawer = true">
        <i class="el-icon-s-fold" />
      </a>
    </div>
    <Drawer
      title="网站导航"
      :with-header="true"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="()=>(drawer=false)"
      size="70%"
    >
      <div class="content">
        <div class="categroy">
          <div class="links">
            <a
              href="javascript:;"
              class="link"
              v-for="(cat,i) in category"
              :key="i"
              @click="onClick(cat.url)"
              v-show="cat.sub.length==0"
            >{{cat.zh.name}}</a>
          </div>
          <Collapse
            v-model="activeNames"
            @change="handleChange"
            v-for="(cat,i) in category"
            :key="i"
            :accordion="true"
          >
            <CollapseItem :title="cat.zh.name" :name="i" v-show="cat.sub.length>0">
              <a
                href="javascript:;"
                class="link sub-link"
                v-for="(sub,j) in cat.sub"
                :key="`sub-${j}`"
                @click="onClick(sub.url)"
              >{{sub.zh.name}}</a>
            </CollapseItem>
          </Collapse>
        </div>
        <div class="contact">
          <img class="icon" src="@/images/icon_contact.png" alt="icon" />
          <span>{{contact}}</span>
        </div>
      </div>
    </Drawer>
  </div>
</template>

<script>
import { Drawer, Collapse, CollapseItem } from 'element-ui'

export default {
  name: 'header-mobile',
  props: {
    category: Array,
    contact: String,
    onShow: { required: false, type: Function },
  },
  components: { Drawer, Collapse, CollapseItem },
  data() {
    return {
      drawer: false,
      activeNames: null,
    }
  },
  mounted() {},
  methods: {
    onClick(url) {
      this.$router.push(url)
      this.drawer = false
    },
    handleChange(val) {
      // console.log(val)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import './index.less';
</style>
